import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { closeOrderSuccess } from '../../redux/actionCreators/alert';

// Shown app-wide once an order is booked (see openOrderSuccess)
export default function OrderSuccessDialog() {
    const { isOrderSuccess, orderSuccess } = useSelector((state) => state.LoaderReducers)
    const dispatch = useDispatch()

    const { cOrderID, nAmount } = orderSuccess || {}

    const handleClose = () => dispatch(closeOrderSuccess())

    return (
        <Dialog
            open={isOrderSuccess}
            onClose={handleClose}
            fullWidth
            maxWidth='xs'
            aria-labelledby="order-success-title"
        >
            <DialogContent sx={{ textAlign: 'center', p: '32px 24px 24px' }}>
                <CheckCircleRoundedIcon color='success' sx={{ fontSize: 72 }} />
                <Box mt='12px'>
                    <Typography id="order-success-title" variant='t20_600'>
                        Order placed successfully!
                    </Typography>
                </Box>
                {cOrderID &&
                    <Box mt='12px'>
                        <Typography color='grey.600' variant='t14_400'>
                            Order ID: <b>{cOrderID}</b>
                        </Typography>
                    </Box>
                }
                {nAmount !== undefined && nAmount !== null &&
                    <Box mt='4px'>
                        <Typography color='grey.600' variant='t14_400'>
                            Amount: <b>₹{nAmount}</b>
                        </Typography>
                    </Box>
                }
                <Box mt='24px'>
                    <Button variant='contained' fullWidth sx={{ height: '42px', backgroundColor: 'common.Bblack' }} onClick={handleClose}>
                        <Typography color='inherit' variant='t14_400'>Ok</Typography>
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}
